import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Card,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Backdrop,
  CircularProgress,
  Alert,
  Snackbar,
  Avatar,
  Chip
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import apiRequest from "../../apiRequest";
import { endPoints } from "../../apis";
import { useNavigate } from "react-router-dom"; 


function DriverManagement() {
  const navigate = useNavigate();
  const [drivers, setDrivers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [currentId, setCurrentId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [role, setRole] = useState('driver')
  const [searchValue, setSearchValue] = useState('');

  // Fetch category with pagination
  const getDrivers = useCallback(
    async (page, searchValue) => {
      setLoading(true);
      try {
        const params = { page, total: totalItems, role: role , search: searchValue };
        const headers = {
          // "x-access-token": accessToken,
        };
        const response = await apiRequest.get(endPoints.GET_DRIVERS,
          params,
          headers,
        );

        if (response.success) {
          const { items, pagination } = response.data;
          setDrivers(items);
          setTotalPages(pagination.total_pages);
          setCurrentPage(pagination.current_page);
          setTotalItems(pagination.totalItems);
        }
      } catch (error) {
        console.error("Error fetching category:", error);
        setError("Failed to fetch category. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [accessToken, totalItems]
  );

  // Fetch category when currentPage changes
  useEffect(() => {
    setAccessToken(localStorage.getItem("access_token"));
    getDrivers(currentPage, searchValue);
  }, [currentPage, getDrivers, searchValue]);




  // Handle delete Category
  const handleDelete = async (id) => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(null);

      // Send the DELETE request to the API
      const response = await apiRequest.delete(
        `${endPoints.DELETE_CATEGORY}/${id}`,
        {
          headers: {
            'x-access-token': accessToken,
          },
        }
      );

      // Handle the response
      if (response.success) {
        setSuccess("Category deleted successfully.");

        // Update the local state to remove the deleted Category
        setDrivers((prev) => prev.filter((categoryData) => categoryData.id !== id));
      } else {
        setError(response.message || "Failed to delete the Category.");
      }
    } catch (error) {
      console.error("Error deleting Category:", error);
      setError("An error occurred while deleting the Category.");
    } finally {
      setLoading(false);
    }
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage); // Update the current page
    }
  };

  const handleStatusToggle = async (id, currentStatus) => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(null);

      const newStatus = currentStatus === "active" ? "inactive" : "active";
      const payload = {
        status: newStatus,
      };

      const headers = {
        'Content-Type': 'application/json',
        'x-access-token': accessToken,
      };

      // Send the PUT request to update the Category status
      const response = await apiRequest.put(
        `${endPoints.STATUS_CATEGORY}/${id}`,
        payload,
        { headers }
      );

      // Handle the response
      if (response.success) {
        setSuccess("Service Type status updated successfully.");

        // Update the local state immediately
        setDrivers((prev) =>
          prev.map((categoryData) =>
            categoryData.id === id ? { ...categoryData, status: newStatus } : categoryData
          )
        );
      } else {
        setError(response.message || 'Failed to update service type status.');
      }
    } catch (error) {
      console.error('Error updating service type status:', error);
      setError('An error occurred while updating the service type status.');
    } finally {
      setLoading(false);
    }
  };

  const handleDetail = async(driver) => {
    navigate(`/dashboard/drivers/details/${driver.id}`);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Drivers List
                </MDTypography>
              </MDBox>
              <MDBox pt={1} px={1}>
                <MDBox
                  pt={1}
                  px={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  gap={2}
                >
                  <TextField
                    label="Search"
                    variant="outlined"
                    margin="normal"
                    placeholder="Search by title or description"
                    style={{ width: "300px" }}
                    value = {searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                  
                </MDBox>
                <TableContainer component={Paper} style={{ marginTop: "1px" }}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Email</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Contact</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Date of Birth</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Address</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Is Online</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Action</TableCell>
                      </TableRow>
                      {drivers.map((driver) => (
                        <TableRow key={driver.id}>
                          <TableCell>
                            <MDBox display="flex" alignItems="center">
                                <Avatar 
                                  src={`${apiRequest.BASE_URL}/${driver?.profile}`} 
                                  sx={{ width: 36, height: 36, mr: 1 }}
                                />
                                <MDTypography variant="button" fontWeight="medium">
                                  {driver?.full_name}
                                </MDTypography>
                            </MDBox>
                          </TableCell>
                          <TableCell> {driver?.email} </TableCell>
                          <TableCell> {driver?.contact} </TableCell>
                          <TableCell> {driver?.dob} </TableCell>
                          <TableCell> {driver?.address} </TableCell>
                          <TableCell> 
                            <Chip 
                              label={driver.is_online == true ? 'Online' : "Offline"} 
                              color={driver.is_online == true ? 'success' : "error"}
                              size="small"
                              style={{ fontWeight: "bold", fontSize: "12px" , color : "white" }}
                            /> 
                          </TableCell>
                          <TableCell>
                            <Switch
                              checked={driver.status === "active"} // Assuming "active" is the active status
                              onChange={() => handleStatusToggle(driver.id, driver.status)}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell>
                            <Button
                              onClick={() => handleDetail(driver)}
                              color="primary"
                              size="small"
                            >
                              Detail
                            </Button>
                            {/* <Button
                              onClick={() => {
                                setCurrentId(driver.id); // Set the service type ID to delete
                                setDeleteDialogOpen(true); // Open the confirmation dialog
                              }}
                              color="error"
                              size="small"
                              style={{ marginLeft: "8px" }}
                            >
                              Delete
                            </Button> */}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Pagination Controls */}
                <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
                  <Button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Button>
                  <MDTypography mx={2}>
                    Page {currentPage} of {totalPages} {/* Display current page and total pages */}
                  </MDTypography>
                  <Button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </Button>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />


      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Delete Driver</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this driver? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setDeleteDialogOpen(false); // Close the dialog
              handleDelete(currentId); // Proceed with deletion
            }}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Loading Backdrop */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Error/Success Snackbar */}
      <Snackbar
        open={!!error || !!success}
        autoHideDuration={3000}
        onClose={() => {
          setError(null);
          setSuccess(null);
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Positioning the Snackbar
      >
        <Alert
          onClose={() => {
            setError(null);
            setSuccess(null);
          }}
          severity={error ? "error" : "success"}
          sx={{ width: '100%' }}
        >
          {error || success}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default DriverManagement;